import { Seo } from "../components/Seo";
import { Header } from "../components/Header";
import { Process } from "../components/Process";
import { Quality } from "../components/Quality";
import { Footer } from "../components/Footer";

export default function ProcessPage() {
  return (
    <main data-testid="process-page">
      <Seo title={"How Cold-Pressed Oil Is Made | PhudG Wooden Ghani Process"} description={"Discover how PhudG oils are made, from carefully selected seeds to traditional wooden ghani extraction, filtration and bottling."} image="/images/seeds.jpg" path="/process" />
      <Header />
      <section className="bg-ink grain relative pt-36 pb-16 overflow-hidden">
        <div className="relative z-10 max-w-7xl mx-auto px-6 lg:px-10">
          <p className="text-xs tracking-[0.4em] uppercase text-gold mb-4">Our Process</p>
          <h1 className="font-serif text-5xl md:text-7xl text-cream tracking-tighter max-w-3xl">
            What "cold-pressed" means <span className="italic text-gold">at PhudG.</span>
          </h1>
          <p className="mt-8 max-w-xl text-base font-light text-cream/65 leading-relaxed">
            Our oil is mechanically extracted from seeds using a traditional
            wooden ghani — not produced through solvent extraction or industrial
            refining. The temperature during extraction stays below 45°C. Slow,
            but honest.
          </p>
        </div>
      </section>
      <Process />
      <Quality />
      <Footer />
    </main>
  );
}
